var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    id: "Airplane-Enabled--Streamline-Plump",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Airplane Enabled Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "airplane-enabled--server-plane-airplane-enabled-on-wireless-mode-internet-network"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#000000",
    strokeLinejoin: "round",
    d: "M22.187 4.024c-1.698 1.239 -4.065 3.78 -4.687 8.546 0.168 2.085 0.35 4.142 0.535 6.12L4.53 26.287A3 3 0 0 0 3 28.902v1.813a1.5 1.5 0 0 0 1.864 1.455l14.2 -3.55c0.53 4.718 0.936 7.81 0.936 7.81l-4.766 4.56A4 4 0 0 0 14 43.88v0.666a1 1 0 0 0 1.357 0.934L24 42.172l8.642 3.308A1 1 0 0 0 34 44.546v-0.666a4 4 0 0 0 -1.234 -2.89L28 36.43s0.406 -3.092 0.936 -7.81l14.2 3.55A1.5 1.5 0 0 0 45 30.715v-1.813a3 3 0 0 0 -1.53 -2.615L29.966 18.69c0.186 -1.979 0.367 -4.035 0.535 -6.12 -0.623 -4.766 -2.99 -7.307 -4.687 -8.546a3.047 3.047 0 0 0 -3.626 0Z",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.6f54917551e57577629f4ccfd3e33870.svg";
export { ForwardRef as ReactComponent };